var LastViewedService = (function () {
    function LastViewedService(locationService) {
        this.locationService = locationService;
        this.lastViewedDevicesKey = 'last-viewed-devices';
    }
    LastViewedService.prototype.addLastViewed = function (devices) {
        if (this.locationService.has('partnerkey')) {
            return;
        }
        var storedDevices = this.getLastViewed();
        var alreadyViewedIndex = -1;
        for (var i = 0; i < storedDevices.length; i++) {
            var storedDeviceItem = storedDevices[i];
            if (storedDeviceItem.length !== devices.length) {
                continue;
            }
            if (storedDeviceItem.every(function (x) {
                return devices.some(function (device) { return device.searchKey === x.searchKey; });
            })) {
                alreadyViewedIndex = i;
                break;
            }
        }
        if (alreadyViewedIndex > -1) {
            storedDevices.splice(alreadyViewedIndex, 1);
        }
        storedDevices.unshift(devices);
        if (storedDevices.length > 5) {
            storedDevices.splice(storedDevices.length - 1, 1);
        }
        var json = JSON.stringify(storedDevices);
        localStorage.setItem(this.lastViewedDevicesKey, json);
    };
    LastViewedService.prototype.clearLastViewedDevices = function () {
        localStorage.setItem(this.lastViewedDevicesKey, JSON.stringify([]));
    };
    LastViewedService.prototype.getLastViewed = function () {
        return this.compatibleLastViewed();
    };
    LastViewedService.prototype.compatibleLastViewed = function () {
        var json = localStorage.getItem(this.lastViewedDevicesKey);
        if (!json) {
            localStorage.setItem(this.lastViewedDevicesKey, JSON.stringify([]));
            return [];
        }
        var devices = JSON.parse(json);
        var foundIncompatible = false;
        for (var i = 0; i < devices.length; i++) {
            var device = devices[i];
            if (!Array.isArray(device)) {
                devices[i] = [device];
                foundIncompatible = true;
            }
        }
        if (foundIncompatible) {
            localStorage.setItem(this.lastViewedDevicesKey, JSON.stringify(devices));
        }
        return devices;
    };
    LastViewedService.$inject = ['locationService'];
    return LastViewedService;
}());
export { LastViewedService };
